import { render, staticRenderFns } from "./FilesTable.vue?vue&type=template&id=498f8d64&scoped=true"
import script from "./FilesTable.vue?vue&type=script&lang=js"
export * from "./FilesTable.vue?vue&type=script&lang=js"
import style0 from "./FilesTable.vue?vue&type=style&index=0&id=498f8d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498f8d64",
  null
  
)

export default component.exports